import { Component, Input, OnInit } from '@angular/core';

/**
 * Displays a status message (error, success, or warning) with optional title and close action.
 */
@Component({
  selector: 'app-status-message',
  templateUrl: './status-message.component.html',
  styleUrls: ['./status-message.component.scss']
})
export class StatusMessageComponent implements OnInit {
  @Input() type: 'error' | 'success' | 'warning' = 'error';
  @Input() message: string = '';
  @Input() title: string = '';
  
  ngOnInit(): void {
  }

  closeTab() {
    window.close();
    setTimeout(() => {
      if (!window.closed) {
        alert("Please close this tab manually and come again from service box.");
      }
    }, 200);
  }

}
